import { variations } from '~/static/feature-flags.json';

export default {
  methods: {
    featIcMaintenance() {
      return variations.find(({ id }) => id === 'feat.ic-maintenance')?.value || false;
    },
    feaIcMaintenanceDB() {
      return variations.find(({ id }) => id === 'feat.ic-maintenance_DB')?.value || false;
    },
    feaIcMaintenanceNetwork() {
      return variations.find(({ id }) => id === 'feat.ic-maintenance_network')?.value || false;
    },
    feaIcMaintenanceSecurity() {
      return variations.find(({ id }) => id === 'feat.ic-maintenance_security')?.value || false;
    },
    feaIcMaintenanceTraffic() {
      return variations.find(({ id }) => id === 'feat.ic-maintenance_traffic')?.value || false;
    },
    feaIcMaintenanceUpdate() {
      return variations.find(({ id }) => id === 'feat.ic-maintenance_update')?.value || false;
    },
    feaIcMaintenanceThirdPartyFailure() {
      return variations.find(({ id }) => id === 'feat.ic-maintenance_third_party_failure')?.value || false;
    },

    /**
     * variation: feat.ic_food_qualification
     * Target:
     * - CountryCode is [US, CA, ZA, IE, GB, PL, SE, NL] & not null
     * - & ready is true & not null
     * - & skills is on of: [ [PHOTO, VIDEO, DRONE, MATTERPORT, 360 ] / [Food, Nourriture ] / [awesome / validated / declined]]
     * @param feature
     * @returns {any}
     */
    featIcQualif() {
      return false;
    },
    featIcNotificationsEnabled() {
      return variations.find(({ id }) => id === 'feat.ic_category_notifications')?.value || false;
    },
    featHideOSC() {
      return variations.find(({ id }) => id === 'feat.ic_hide_osc_number')?.value || false;
    },
    feat21DaysLimitation() {
      return variations.find(({ id }) => id === 'feat.ic-21-days-limitation')?.value || false;
    },
    featIcSelectionLimit() {
      return variations.find(({ id }) => id === 'feat.ic-selection-limits')?.value || false;
    },
    featIcMapRefacto() {
      return variations?.find(({ id }) => id === 'feat.ic-map-refacto')?.value || false;
    },
    featIcMenuTaggingRefacto() {
      return variations.find(({ id }) => id === 'feat.ic-menu-tagging-refacto')?.value;
    },
    featIcAutoValidation() {
      return variations?.find(({ id }) => id === 'feat.ic_auto_validation')?.value || false;
    },
    /**
     * Activate the V3 migration banners (on home page & mission page)
     * @return {any}
     */
    featIcMigration() {
      return variations?.find(({ id }) => id === 'feat.ic-v2-v3-migration')?.value || false;
    },
  },
};
